import {
  AuthLoginRepresentativeRequest,
  FirstChangePasswordRepresentativeCommandRequest,
  ResetPasswordAuthUserCommandRequest,
} from 'domain/entities/authUser'
import {
  FirstChangeRepresentativeCommand,
  LoginRepresentativeCommand,
  LogoutRepresentativeCommand,
  recoverPasswordRepresentativeCommand,
  refreshTokenRepresentativeCommand,
  resetPasswordRepresentativeCommand,
} from 'application/commands/authUser'

import AuthUserRepository from 'infraestructure/repositories/authUserRepository'

const authUserRepository = new AuthUserRepository()

export class AuthUserController {
  static async login(data: AuthLoginRepresentativeRequest) {
    return await LoginRepresentativeCommand(authUserRepository, data)
  }

  static async firstChangePass(data: FirstChangePasswordRepresentativeCommandRequest) {
    return await FirstChangeRepresentativeCommand(authUserRepository, data)
  }

  static async logout(refreshToken: string) {
    return await LogoutRepresentativeCommand(authUserRepository, refreshToken)
  }

  static async recoverPassword(identificationNumber: string) {
    return await recoverPasswordRepresentativeCommand(authUserRepository, identificationNumber)
  }

  static async refreshToken(token: string) {
    return await refreshTokenRepresentativeCommand(authUserRepository, token)
  }

  static async resetPassword(data: ResetPasswordAuthUserCommandRequest) {
    return await resetPasswordRepresentativeCommand(authUserRepository, data)
  }
}
